module.exports = __webpack_public_path__ + "static/media/up-arrow.d693036e.png";